import {lemon, lemonReady} from "../common/lemon";

lemonReady(function (){

});